<template>
  <CRow>
    <CCol sm="12">

      <CCard>

        <CCardHeader>
          <CIcon name="cil-text"/>
          Einen neuen Textbaustein anlegen
        </CCardHeader>

        <CCardBody>
          <ValidationObserver v-slot="{ invalid }">
            <CForm class="no-mb" @submit.prevent="newTextbaustein()">

              <FreizeitText v-model="name" formLabel="Name"/>
              <FreizeitTextArea v-model="text" formLabel="Text des Textbausteins" rules="required"/>

              <FormError v-if="formError" :errormessage="formError"/>

              <CRow class="mt-4">
                <CCol col="12" class="text-right">
                  <CButton color="primary" class="px-4" :disabled="invalid" type="submit">Textbaustein anlegen</CButton>
                </CCol>
              </CRow>

            </CForm>
          </ValidationObserver>
        </CCardBody>

      </CCard>

    </CCol>
  </CRow>
</template>

<script>
import Vue from 'vue'
import FormError from '@/components/FormError'
import FreizeitText from '@/components/FormElements/Text'
import FreizeitTextArea from '@/components/FormElements/TextArea'

export default {
  name: 'MitarbeiterNew',
  components: {
    FormError,
    FreizeitText,
    FreizeitTextArea
  },
  data () {
    return {
      name: '',
      text: '',
      formError: null
    }
  },
  mounted () {
    this.setDefaults()
  },
  methods: {
    setDefaults () {
      this.name = ''
      this.text = ''
      this.formError = null
    },
    newTextbaustein () {
      Vue.axios.post('/textbaustein/post', {
        name: this.name,
        text: this.text
      }).then((response) => {
        this.$router.push({ path: '/textbausteine/uebersicht' })
        this.$snotify.success('Der neue Textbaustein wurde angelegt.', {
          position: 'rightTop',
          timeout: 4000
        })
        this.setDefaults()
      }).catch((error) => {
        this.formError = error.response.data
      })
    }
  }
}
</script>
